import React, { CSSProperties } from 'react';
import useGame from '../../contexts/useGame';

export type SiteLogoProps = {
  size?: number;
  alt?: string;
  hasTitle?: boolean;
  style?: CSSProperties;
};

function SiteLogo({
  size = 64,
  hasTitle = false,
  alt,
  style,
}: SiteLogoProps): JSX.Element | null {
  const game = useGame();

  if (!game) {
    return null;
  }

  return (
    <img
      className={'site-logo'}
      src={hasTitle ? game.headerLogoUrl : game.siteLogoImageUrl}
      alt={alt ?? game.siteTitle}
      style={{
        ...(style ?? {}),
        width: hasTitle ? undefined : size,
        height: hasTitle ? size : (size * 63) / 64,
      }}
    />
  );
}

export default SiteLogo;
